import {
  ClosedRangehokgr73im9z3 as ClosedRange,
  contains21620uw5ew03f as contains,
  isEmpty2lvc2zgoeh0ds as isEmpty,
  OpenEndRange1a2my95ycmxk8 as OpenEndRange,
} from './Range.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../js/bitUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function isEmpty_0() {
  return !this.m2(this.j1(), this.k1());
}
var ClosedFloatingPointRangeClass;
function ClosedFloatingPointRange() {
  if (ClosedFloatingPointRangeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ClosedFloatingPointRange', VOID, VOID, [ClosedRange()]);
    ClosedFloatingPointRangeClass = $;
  }
  return ClosedFloatingPointRangeClass;
}
function rangeTo(_this__u8e3s4, that) {
  return new (ComparableRange())(_this__u8e3s4, that);
}
function rangeTo_0(_this__u8e3s4, that) {
  return new (ClosedDoubleRange())(_this__u8e3s4, that);
}
function rangeUntil(_this__u8e3s4, that) {
  return new (OpenEndDoubleRange())(_this__u8e3s4, that);
}
function checkStepIsPositive(isPositive, step) {
  if (!isPositive)
    throw IllegalArgumentException().a1('Step must be positive, was: ' + toString(step) + '.');
}
var ComparableRangeClass;
function ComparableRange() {
  if (ComparableRangeClass === VOID) {
    class $ {
      constructor(start, endInclusive) {
        this.ss_1 = start;
        this.ts_1 = endInclusive;
      }
      j1() {
        return this.ss_1;
      }
      k1() {
        return this.ts_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof ComparableRange()) {
          tmp = this.i1() && other.i1() || (equals(this.j1(), other.j1()) && equals(this.k1(), other.k1()));
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.i1() ? -1 : imul(31, hashCode(this.j1())) + hashCode(this.k1()) | 0;
      }
      toString() {
        return toString(this.j1()) + '..' + toString(this.k1());
      }
    }
    protoOf($).l2 = contains;
    protoOf($).i1 = isEmpty;
    initMetadataForClass($, 'ComparableRange', VOID, VOID, [ClosedRange()]);
    ComparableRangeClass = $;
  }
  return ComparableRangeClass;
}
var ClosedDoubleRangeClass;
function ClosedDoubleRange() {
  if (ClosedDoubleRangeClass === VOID) {
    class $ {
      constructor(start, endInclusive) {
        this.us_1 = start;
        this.vs_1 = endInclusive;
      }
      j1() {
        return this.us_1;
      }
      k1() {
        return this.vs_1;
      }
      ws(a, b) {
        return a <= b;
      }
      m2(a, b) {
        var tmp = typeof a === 'number' ? a : THROW_CCE();
        return this.ws(tmp, typeof b === 'number' ? b : THROW_CCE());
      }
      xs(value) {
        return value >= this.us_1 && value <= this.vs_1;
      }
      l2(value) {
        return this.xs(typeof value === 'number' ? value : THROW_CCE());
      }
      i1() {
        return !(this.us_1 <= this.vs_1);
      }
      equals(other) {
        var tmp;
        if (other instanceof ClosedDoubleRange()) {
          tmp = this.i1() && other.i1() || (this.us_1 === other.us_1 && this.vs_1 === other.vs_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.i1() ? -1 : imul(31, getNumberHashCode(this.us_1)) + getNumberHashCode(this.vs_1) | 0;
      }
      toString() {
        return '' + this.us_1 + '..' + this.vs_1;
      }
    }
    initMetadataForClass($, 'ClosedDoubleRange', VOID, VOID, [ClosedFloatingPointRange()]);
    ClosedDoubleRangeClass = $;
  }
  return ClosedDoubleRangeClass;
}
var OpenEndDoubleRangeClass;
function OpenEndDoubleRange() {
  if (OpenEndDoubleRangeClass === VOID) {
    class $ {
      constructor(start, endExclusive) {
        this.ys_1 = start;
        this.zs_1 = endExclusive;
      }
      j1() {
        return this.ys_1;
      }
      lr() {
        return this.zs_1;
      }
      xs(value) {
        return value >= this.ys_1 && value < this.zs_1;
      }
      l2(value) {
        return this.xs(typeof value === 'number' ? value : THROW_CCE());
      }
      i1() {
        return !(this.ys_1 < this.zs_1);
      }
      equals(other) {
        var tmp;
        if (other instanceof OpenEndDoubleRange()) {
          tmp = this.i1() && other.i1() || (this.ys_1 === other.ys_1 && this.zs_1 === other.zs_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.i1() ? -1 : imul(31, getNumberHashCode(this.ys_1)) + getNumberHashCode(this.zs_1) | 0;
      }
      toString() {
        return '' + this.ys_1 + '..<' + this.zs_1;
      }
    }
    initMetadataForClass($, 'OpenEndDoubleRange', VOID, VOID, [OpenEndRange()]);
    OpenEndDoubleRangeClass = $;
  }
  return OpenEndDoubleRangeClass;
}
//region block: exports
export {
  ClosedFloatingPointRange as ClosedFloatingPointRange3bek8kkkwkj9x,
  checkStepIsPositive as checkStepIsPositive70940ky00dt4,
  rangeTo_0 as rangeTo5xinnemk0fd3,
  rangeTo as rangeTo3js8ciqegc9cl,
  rangeUntil as rangeUntilvkeu8z37zujo,
};
//endregion

//# sourceMappingURL=Ranges.mjs.map
